
const LEVEL_STYLE = { 0: 'bg-red-100 text-red-700', 1: 'bg-orange-100 text-orange-700', 2: 'bg-amber-100 text-amber-700', 3: 'bg-lime-100 text-lime-700', 4: 'bg-emerald-100 text-emerald-700', 5: 'bg-green-200 text-green-800' };
const pct = (v) => (v == null ? '—' : `${(v * 100).toFixed(1)}%`);
const fmtD = (iso) => (iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}` : '—');
const WD = ['Du', 'Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ'];
export const wd = (iso) => (iso ? WD[new Date(`${iso}T00:00:00Z`).getUTCDay()] : '');
const isWeekend = (iso) => { const d = iso ? new Date(`${iso}T00:00:00Z`).getUTCDay() : 1; return d === 0 || d === 6; };
export const isTotal = (k) => k.includes('total_otd');

export const shortLabel = (k, label) => {
  const s = k.toLowerCase();
  if (s.includes('eta')) return 'ETA';
  if (s.includes('agentie_1_hd')) return 'OT1 HD';
  if (s.includes('agentie_2_hd')) return 'OT2 HD';
  if (s.includes('1_pf')) return 'OT1 PF';
  if (isTotal(s)) return 'Total OTD';
  return (label || k).slice(0, 8);
};

const Lvl = ({ level, small }) => (
  level == null
    ? <span className="text-slate-400">—</span>
    : <span className={`inline-block rounded font-semibold ${small ? 'px-1 text-[10px]' : 'px-1.5 py-0.5 text-xs'} ${LEVEL_STYLE[level] || 'bg-slate-100 text-slate-700'}`}>{level === 0 ? 'ZERO' : `L${level}`}</span>
);

const Delta = ({ cur, prev, compact }) => {
  if (cur == null || prev == null) return null;
  const d = Math.round((cur - prev) * 1000) / 10;
  if (d === 0) return <span className="text-[8px] text-slate-400">=</span>;
  return <span className={`text-[8px] ${d > 0 ? 'text-emerald-600' : 'text-red-600'}`}>{d > 0 ? '▲' : '▼'}{compact ? '' : Math.abs(d)}</span>;
};

export default function LevelHistoryTable({ data, compact = false }) {
  const rows = data?.rows || [];
  const cols = data?.kpi_order || [];
  if (!rows.length) return <div className="text-sm text-slate-500 py-4 text-center" data-testid="level-history-empty">Istoricul Level se construiește începând cu următoarea raportare.</div>;

  const kpiKeys = cols.filter((c) => !isTotal(c.key)).map((c) => c.key);
  const weakest = (values) => {
    const cand = kpiKeys.filter((k) => values[k] != null);
    return cand.length ? cand.reduce((a, b) => (values[b] < values[a] ? b : a)) : null;
  };
  const agency = rows[0]?.reference?.agency;
  const cell = compact ? 'px-0.5 py-1.5' : 'px-2 py-2';

  return (
    <div data-testid="level-history">
      <div className="text-[11px] text-slate-500 mb-2">{rows.length} rapoarte Level · data mare = ziua măsurată (la ce se referă datele); dedesubt, raportul din care provine · cel mai slab indicator e marcat cu <span className="inline-block w-2.5 h-2.5 rounded-sm bg-amber-200 align-middle" /></div>
      <div className="overflow-x-auto -mx-1">
        <table className={`w-full table-fixed ${compact ? 'text-[10px]' : 'text-xs'}`} data-testid="level-history-table">
          <thead>
            <tr className="text-slate-500 border-b border-slate-200">
              <th className={`text-left font-medium ${cell} ${compact ? 'w-[52px]' : 'w-[80px]'}`}>Zi măsurată</th>
              {cols.map((c) => <th key={c.key} className={`text-right font-medium whitespace-nowrap ${cell} ${isTotal(c.key) ? 'text-slate-800' : ''}`} title={c.label}>{shortLabel(c.key, c.label)}</th>)}
              <th className={`text-center font-medium ${cell} ${compact ? 'w-[38px]' : 'w-[60px]'}`}>Level</th>
            </tr>
          </thead>
          <tbody>
            {agency && (
              <tr className="border-b-2 border-slate-200 bg-slate-50/70 text-slate-500" data-testid="level-history-agency">
                <td className={`whitespace-nowrap italic ${cell}`} title={`${agency.name} · zi măsurată ${fmtD(rows[0].day)}`}>Agenție</td>
                {cols.map((c) => <td key={c.key} className={`text-right whitespace-nowrap ${cell}`}>{pct(agency.values?.[c.key])}</td>)}
                <td className={`text-center ${cell}`}><Lvl level={agency.level} small={compact} /></td>
              </tr>
            )}
            {rows.map((r, i) => {
              const prev = rows[i + 1];
              const weak = weakest(r.values);
              return (
                <tr key={r.day} className={`border-b border-slate-100 ${isWeekend(r.day) ? 'bg-slate-50/60' : ''}`} data-testid={`level-history-row-${r.day}`}>
                  <td className={`whitespace-nowrap ${cell}`}>
                    <div className="font-semibold text-slate-800 leading-tight">{wd(r.day)} {fmtD(r.day)}</div>
                    {r.report_date && r.report_date !== r.day && <div className="text-[9px] text-slate-400 leading-tight" title="Raportul din care provin aceste date">raport {fmtD(r.report_date)}</div>}
                  </td>
                  {cols.map((c) => {
                    const v = r.values[c.key];
                    const tot = isTotal(c.key);
                    return (
                      <td key={c.key} className={`text-right whitespace-nowrap ${cell} ${weak === c.key ? 'bg-amber-100 text-amber-900 font-semibold' : tot ? 'font-semibold text-slate-900' : 'text-slate-700'}`} data-testid={weak === c.key ? `level-history-weak-${r.day}` : undefined}>
                        {pct(v)}<Delta cur={v} prev={prev?.values?.[c.key]} compact={compact} />
                      </td>
                    );
                  })}
                  <td className={`text-center ${cell}`}><Lvl level={r.level} small={compact} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {!compact && (
        <div className="text-[11px] text-slate-500 mt-2 flex flex-wrap gap-x-3 gap-y-1">
          {cols.map((c) => <span key={c.key}><b>{shortLabel(c.key, c.label)}</b> = {c.label}</span>)}
        </div>
      )}
    </div>
  );
}
